import { parseDOM } from 'htmlparser2';

const convertAttributes = attributes => {
	const [el] = parseDOM(`<btnAttributes ${attributes}/>`);
	return el.attribs || {};
};

export default convertAttributes;



// WEBPACK FOOTER //
// ./src/utils/attributes.js